import { fetchUtils } from "react-admin";
import { ereaseTokens, getAccessToken, getAuthHeaders, setTokens } from "./authUtils";
import { apiUrl } from "./constant";

const httpClient = fetchUtils.fetchJson;

const authProvider = {
  // authentication
  login: async ({ username, password }) => {
    const url = `${apiUrl}/auth/login`;
    const { status, json } = await httpClient(url, {
      method: "POST",
      body: JSON.stringify({ username, password }),
    });

    if (status < 200 || status >= 300) {
      throw new Error(json.message);
    }

    setTokens(json.access_token, json.access_token_expires_in, json.refresh_token);
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 401) {
      ereaseTokens();
      return Promise.reject({ message: "session.expired" });
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  checkAuth: async () => {
    const accessToken = await getAccessToken().catch(() => {
      window.location = "/#/login";
    });

    return accessToken ? Promise.resolve() : Promise.reject({ message: "login.required" });
  },

  logout: () => {
    ereaseTokens();
    //localStorage.removeItem('access_token');
    //localStorage.removeItem('refresh_token');
    return Promise.resolve();
  },
  getIdentity: () => {
    return Promise.resolve();
  },
  // authorization
  // getPermissions: async (params) => {
  //   console.log("auth: getPermissions", JSON.stringify(params));

  //   const accessToken = await getAccessToken();
  //   const decodedToken = decodeJwt(accessToken);

  //   const url = `${apiUrl}/users/${decodedToken.sub}`;

  //   const { status, json } = await httpClient(url, {
  //     method: "GET",
  //     headers: await getAuthHeaders(),
  //   });

  //   if (status < 200 || status >= 300) {
  //     throw new Error(json.message);
  //   }

  //   if (!json) {
  //     throw new Error("no user is found");
  //   }

  //   //Store current user info to local storage
  //   localStorage.setItem("user", JSON.stringify(json));

  //   // get roles permissions
  //   const roles = json.roles;

  //   const rolePromises = roles.map((r) => {
  //     return _getPermissionsByRole(r);
  //   });

  //   const roleResults = await Promise.all(rolePromises);

  //   var permissions = [];

  //   for (const r of roleResults) {
  //     permissions = permissions.concat(r);
  //   }

  //   return permissions;
  // },
  getPermissions: async () => {
    const url = `${apiUrl}/users/info`;

    const { status, json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    if (status < 200 || status >= 300) {
      throw new Error(json.message);
    }

    if (!json) {
      throw new Error("no user is found");
    }

    //Store current user info to local storage
    // localStorage.setItem("user", JSON.stringify(json));

    // // get roles permissions
    // const roles = json.roles;

    // const rolePromises = roles.map((r) => {
    //   return _getPermissionsByRole(r);
    // });

    // const roleResults = await Promise.all(rolePromises);

    var permissions = json.roles_info.permissions;

    // for (const r of roleResults) {
    //   permissions = permissions.concat(r);
    // }

    return permissions;
  },
  changePassword: async ({ old_password, new_password }) => {
    const url = `${apiUrl}/users/change-password`;
    const { status, json } = await httpClient(url, {
      method: "POST",
      body: JSON.stringify({ old_password, new_password }),
    });

    if (status < 200 || status >= 300) {
      throw new Error(json.message);
    }
  },
};

export default authProvider;
